export default "__VITE_ASSET__e09d8adb__"